import WebFont from 'webfontloader'
import { isSystemFontFamily } from './googleFonts'

const loaded = new Set()

/**
 * Carrega uma família Google Fonts sob demanda (webfontloader).
 */
export function loadGoogleFont(family) {
  const name = String(family || '').trim()
  if (!name || isSystemFontFamily(name)) return
  if (loaded.has(name)) return
  loaded.add(name)
  try {
    WebFont.load({
      google: {
        families: [`${name}:400,500,600,700`],
      },
    })
  } catch {
    /* ignore */
  }
}
